export const loadGoogleScript = () => {
  const isGoogleScriptLoaded = document.querySelector(
    'script[src="https://apis.google.com/js/api.js"]'
  );
  if (isGoogleScriptLoaded) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.onload = () => {
      window.gapi.load('picker', () => {
        resolve();
      });
    };
    document.head.appendChild(script);
  });
};

export const createGooglePickerObject = (googleProfile, pickerCallback) => {
  // Restrict picker to spreadsheets only.
  const docsView = new window.google.picker.DocsView()
    .setIncludeFolders(false)
    .setSelectFolderEnabled(false)
    .setMimeTypes('application/vnd.google-apps.spreadsheet');

  const picker = new window.google.picker.PickerBuilder()
    .setAppId(googleProfile.googleAppId)
    .setOAuthToken(googleProfile.accessToken)
    .addView(docsView)
    .setCallback(pickerCallback)
    .build();

  picker.setVisible(true);
};
